import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  getCurrentLanguage(): string {
    // 1. Intentar leer cookie de Google Translate
    const cookieMatch = document.cookie.match('(^|;) ?googtrans=([^;]*)(;|$)');
    if (cookieMatch && cookieMatch[2]) {
      const lang = cookieMatch[2].split('/')[2];
      if (lang) return lang;
    }

    // 2. Buscar select de Google Translate
    const selects = document.getElementsByTagName('select');
    for (let i = 0; i < selects.length; i++) {
      if (/goog-te-combo/.test(selects[i].className)) {
        const value = (selects[i] as HTMLSelectElement).value;
        if (value) return value;
      }
    }

    // 3. Verificar atributo lang del HTML
    const htmlLang = document.documentElement.lang;
    if (htmlLang && htmlLang !== 'es') {
      return htmlLang;
    }

    // 4. Default español
    return 'es';
  }

  isCatalan(): boolean {
    return this.getCurrentLanguage() === 'ca';
  }
}
